import { render, staticRenderFns } from "./LearningStatPanel.vue?vue&type=template&id=4cefbe90"
import script from "./LearningStatPanel.vue?vue&type=script&lang=js"
export * from "./LearningStatPanel.vue?vue&type=script&lang=js"
import style0 from "./LearningStatPanel.vue?vue&type=style&index=0&id=4cefbe90&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports